import React, { FC, useEffect, useState } from "react";
import { dictionary } from "../../untils/dictionary";
import { sendInvitationVerfication, t } from "../../helpers/userHelper";
import { Form, Modal } from "venice-ui";
import { memeberRoleScope } from "../../definitions/organizations";
import { apiCall } from "../../untils/apiCall";
import { useStoreActions, useStoreState } from "../../store";
import { getMemberDetails } from "../../helpers/organizationHelper";
import { ErrorArea } from "../SingIn/Login.styles";
import { emailFormatCheck } from "../PasswordCheck/checks";

interface IUserModal {
  handleClose: () => void;
  memberID?: string;
  isOpen: boolean;
}
export const UserModal: FC<IUserModal> = ({
  handleClose,
  memberID,
  isOpen,
}) => {
  const { orgID, lang } = useStoreState((state) => state.user.userDetails);
  const { members, invitations, contracts } = useStoreState((state) => state.organization);
  const [loadAction, setLoadAction] = useState(false);
  const [userDetails, setUserDetails] = useState({
    email: "",
    role: "admin",
  });
  const [error, setError] = useState({
    show: false,
    msg: "",
  });

  const { saveMemberRole, addInvitation } = useStoreActions(
    (actions) => actions.organization
  );

  useEffect(() => {
    if (memberID) {
      const details = getMemberDetails(members, memberID, contracts);

      setUserDetails({
        email: details.email,
        role: details.role,
      });
    }
  }, [memberID]);

  const updateForm = (field: string, value: string) => {
    setError({
      show: false,
      msg: "",
    });
    setUserDetails({
      ...userDetails,
      [field]: value,
    });
  };
  const sendInvatation = async () => {
    setLoadAction(true);
    setError({
      show: false,
      msg: "",
    });
    
    const isValid = sendInvitationVerfication(
      userDetails.email,
      invitations,
      members
    );
    if (isValid) {
      const options = {
        email: userDetails.email,
        role: userDetails.role,
        orgID: orgID,
        date: Date.now(),
        lang: lang,
      };
      await apiCall("organization/sendInvitation", options, (response: any) => {
        if (response.success) {
          addInvitation({
            id: response.invitationID,
            orgID: orgID,
            date: options.date,
            role: userDetails.role,
            user: userDetails.email,
          });
          setLoadAction(false);
          handleClose();
        } else {
          setError({
            show: true,
            msg: response.errorMsg,
          });
          setLoadAction(false);
        }
      });
    } else {
      const msg = !emailFormatCheck(userDetails.email)
        ? t(dictionary.wrongEmail)
        : t(dictionary.alreadyInvitation);
      setError({
        show: true,
        msg: msg,
      });
      setLoadAction(false);
    }
  };

  const saveMember = async () => {
    const options = {
      memberID: memberID,
      role: userDetails.role,
      orgID: orgID,
    };
    await apiCall(
      "organization/saveMemberDetails",
      options,
      (response: any) => {
        saveMemberRole({ memberID: memberID || "", role: userDetails.role });
        handleClose();
      }
    );
  };

  const submitAction = () => {
    if (memberID) {
      saveMember();
    } else {
      sendInvatation();
    }
  };
  const userForm = {
    action: updateForm,
    data: [
      {
        type: "text",
        label: t(dictionary.email),
        value: userDetails?.email,
        name: "email",
        autofocus: true,
        submit: () => submitAction(),
        isDisabled: !!memberID,
      },
      {
        type: "select",
        label: t(dictionary.role),
        value: userDetails.role,
        options: memeberRoleScope,
        zIndex: 1000,
        position: "left",
        name: "role",
      },
    ],
  };
  return (
    <Modal
      title={memberID ? t(dictionary.editUser) : t(dictionary.addUser)}
      labelClose={t(dictionary.close)}
      labelConfirm={t(dictionary.add)}
      handleClose={handleClose}
      handleConfirm={submitAction}
      submitDisabled={userDetails.email.length === 0}
      size="small"
      submitLoader={loadAction}
      isOpen={isOpen}
      exitOnEsc={true}
    >
      <Form formData={userForm} />
      {error.show && <ErrorArea>{t(dictionary.usedEmailAdress)}</ErrorArea>}
    </Modal>
  );
};
